// BatchCacheService.ts
export class BatchCacheService {
    private static getCacheKey(orgId: string, collectionId: string): string {
      return `batch_cache_${orgId}_${collectionId}`;
    }
  
    private static getBatchKey(orgId: string, collectionId: string, batchNumber: number): string {
      return `batch_${orgId}_${collectionId}_${batchNumber}`;
    }
  
    static getCachedBatch(orgId: string, collectionId: string, batchNumber: number): any[] | null {
      try {
        const batchKey = this.getBatchKey(orgId, collectionId, batchNumber);
        const cached = sessionStorage.getItem(batchKey);
        return cached ? JSON.parse(cached) : null;
      } catch (error) {
        console.warn('Error reading batch from cache:', error);
        return null;
      }
    }
  
    static setCachedBatch(orgId: string, collectionId: string, batchNumber: number, documents: any[]): void {
      try {
        const batchKey = this.getBatchKey(orgId, collectionId, batchNumber);
        sessionStorage.setItem(batchKey, JSON.stringify(documents));
        
        // Also track which batches are cached
        this.addToCachedBatchesList(orgId, collectionId, batchNumber);
      } catch (error) {
        console.warn('Error caching batch:', error);
      }
    }
  
    static getCachedBatches(orgId: string, collectionId: string): number[] {
      try {
        const cacheKey = this.getCacheKey(orgId, collectionId);
        const cached = sessionStorage.getItem(cacheKey);
        return cached ? JSON.parse(cached) : [];
      } catch (error) {
        console.warn('Error reading cached batches list:', error);
        return [];
      }
    }
  
    private static addToCachedBatchesList(orgId: string, collectionId: string, batchNumber: number): void {
      const cachedBatches = this.getCachedBatches(orgId, collectionId);
      if (!cachedBatches.includes(batchNumber)) {
        cachedBatches.push(batchNumber);
        const cacheKey = this.getCacheKey(orgId, collectionId);
        sessionStorage.setItem(cacheKey, JSON.stringify(cachedBatches));
      }
    }
  
    static clearCache(orgId: string, collectionId: string): void {
      try {
        const cachedBatches = this.getCachedBatches(orgId, collectionId);
        
        // Remove individual batch caches
        cachedBatches.forEach(batchNumber => {
          const batchKey = this.getBatchKey(orgId, collectionId, batchNumber);
          sessionStorage.removeItem(batchKey);
        });
        
        // Remove the cached batches list
        const cacheKey = this.getCacheKey(orgId, collectionId);
        sessionStorage.removeItem(cacheKey);
      } catch (error) {
        console.warn('Error clearing cache:', error);
      }
    }
  
    static getBatchDocumentsWithCache(
      orgId: string, 
      collectionId: string, 
      batchNumbers: number[]
    ): { cached: any[], uncachedBatches: number[] } {
      const cached: any[] = [];
      const uncachedBatches: number[] = [];
  
      batchNumbers.forEach(batchNumber => {
        const cachedBatch = this.getCachedBatch(orgId, collectionId, batchNumber);
        if (cachedBatch) {
          cached.push(...cachedBatch);
        } else {
          uncachedBatches.push(batchNumber);
        }
      });
  
      return { cached, uncachedBatches };
    }
  }